<template>
  <div class="spreaderBind6"
    style="width: 100%; height:100%; display: flex;justify-content: center;align-items: center;flex-direction: column;">
    <div style="width:100%;height:100%;display: flex; justify-content: center; align-items: center;">
      <div v-if="bindFlag == 0"
        style="width: 100%; height: 600px; background: #FEFEFE;box-shadow: 0px 12px 32px 0px rgba(0, 56, 168, 0.2);border-radius: 40px;position: relative;">
        <div class="spreaderBind7" :style="style6">
          <p class="spreaderBind8" :style="style5">绑定手机</p>
        </div>
        <div style="width: 100%;height:100%;margin-top: 15%;">
          <div style="width: 75%;display: flex;align-items: center;flex-direction: column;margin: auto;">
            <input class="spreaderBind1" type="number" v-model="tel" placeholder="手机号" :style="style1" />
            <div class="spreaderBind2"
              style="width: 100%;display: flex;align-items: center;flex-direction: row;margin-top: 40px;">
              <input class="spreaderBind3" type="number" v-model="code" placeholder="请输入手机验证码" :style="style2" />
              <el-button class="spreaderBind4" :style="style3" @click="getTelCode(tel)">
                {{ codeButtonStr }}
              </el-button>
            </div>
            <el-button plain class="spreaderBind5" :style="style4" @click="bind()">
              确定
            </el-button>
          </div>
        </div>
      </div>
      <div v-if="bindFlag == 1"
        style="width: 100%; height: 600px; background: #FEFEFE;box-shadow: 0px 12px 32px 0px rgba(0, 56, 168, 0.2);border-radius: 40px;display: flex;justify-content: center;align-items: center;">
        <p style="font-size: 50px;">{{hintMsg}}</p>
      </div>
    </div>
    <div class="spreaderBind9" :style="style7">
      <p> Copyright 2019 - 2029 | All Rights Reserved IOOFOX 深圳市云方程数据技术有限公司 | <a href="https://beian.miit.gov.cn/"
          target="_blank">粤ICP备2022061985号</a></p>
    </div>
  </div>
</template>

<script>

export default {
  name: "spreaderBind",

  created() {

    document.title = '绑定手机'

    this.uid = this.$route.query.uid;

    if (this.uid == undefined) {
      this.bindFlag = 1;
      this.hintMsg = 'uid参数不正确，请检查';
    } else {

    }

    this.timerNum = 5;
    this.codeButtonStr = '获取验证码';
    this.isGet = false;
    this.codeTime = 60;

    let windowWidth = document.documentElement.clientWidth      //实时屏幕宽度
    let windowHeight = document.documentElement.clientHeight    //实时屏幕高度
    this.style1 = {
      'width': (windowWidth * 0.75) + 'px',
      'font-size': (windowWidth * 0.04) + 'px',
      'height': (windowHeight * 0.05) + 'px',
    }
    this.style2 = {
      'width': (windowWidth * 0.5) + 'px',
      'font-size': (windowWidth * 0.04) + 'px',
      'height': (windowHeight * 0.05) + 'px',
    }
    this.style3 = {
      'width': (windowWidth * 0.3) + 'px',
      'font-size': (windowWidth * 0.04) + 'px',
      'height': (windowHeight * 0.05) + 'px',
      'background': '#8FCD5D',
      'border-radius': '4px',
      'margin-left': '3%',
      'border': '0px',
    }
    this.style4 = {
      'width': (windowWidth * 0.75) + 'px',
      'font-size': (windowWidth * 0.05) + 'px',
      'height': (windowHeight * 0.07) + 'px',
      'font-family': 'Microsoft YaHei',
      'font-weight': '400',
      'margin-top': '60px',
      'background-color': '#347BFF',
      'color': '#FFFFFF',
    }
    this.style5 = {
      'font-size': (windowWidth * 0.05) + 'px',
    }
    this.style6 = {
      'width': (windowWidth * 0.65) + 'px',
      'height': (windowHeight * 0.06) + 'px',
    }
    this.style7 = {
      "font-size": (windowHeight * 0.01) + 'px',
    }
  },
  destroyed: function () {
  },
  mounted: function () {
  },
  methods: {
    login() {
      this.$spost("/spreader/user/login", { tel: this.tel, pwd: this.pwd }).then((res) => {
        if (res.status == 200) {
          sessionStorage.setItem('userInfo', JSON.stringify(res.data));
          this.$router.push('/spreader/home');
        } else {
          this.$message(res.message);
        }
      });
    },
    getTelCode(tel) {
      if (this.isGet == false) {
        //正在获取验证码
        this.$spost("/spreader/user/getTelCode", { tel: tel }).then((res) => {
          if (res.status == 200) {
            this.isGet = true
            this.telCodeInterval = setInterval(() => {
              if (this.codeTime == 0) {
                this.isGet = false;
                this.codeTime = 60;
                this.codeButtonStr = '获取验证码';
                clearInterval(this.telCodeInterval);
              } else {
                this.codeTime = this.codeTime - 1;
                this.codeButtonStr = this.codeTime + '重新发送';
              }
            }, 1000);
          } else {
            this.$message(res.message);
          }
        });
      } else {
      }
    },
    bind() {

      let data = {
        uid: this.uid,
        tel: this.tel,
        code: this.code,
      }
      this.$spost("/spreader/user/bindTel", data).then((res) => {
        if (res.status == 200) {
          this.bindFlag = 1;
          setInterval(() => {
            if (this.timerNum == 0) {
              this.$wx.closeWindow();
            } else {
              this.timerNum = this.timerNum - 1;
              this.hintMsg = '恭喜绑定手机成功，' + this.timerNum + 's后自动关闭页面';
            }
          }, 1000);
        } else {
          this.$message(res.message);
        }
      });
    },

  },
  data() {
    return {
      style1: {},
      style2: {},
      style3: {},
      style4: {},
      style5: {},
      style6: {},
      style7: {},
      tel: '',
      code: '',
      agreementChecked: false,
      codeButtonStr: '',
      bindFlag: 0,
      hintMsg: '',
    };
  },
};
</script>

<style>
.spreaderBind6 {
  background-image: url('../../assets/spreader/background.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
  background-color: #464646;
}

.spreaderBind7 {
  background-image: url('../../assets/spreader/juxin3.png');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: -30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spreaderBind1,
.spreaderBind3 {
  border: 1px solid #b4b3b3;
}

.spreaderBind4 {}

.spreaderBind5 {}

.spreaderBind8 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
}

.spreaderBind9 {
  text-align: center;
  width: 100%;
  background-color: black;
  display: table-cell;
  color: #ffffff;
  font-size: 10px;
}

.spreaderBind9 a {
  text-decoration: none;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/spreader/bind.vue